import ConfirmPhoneAdvancedView from './ConfirmPhoneAdvancedView'
export default ConfirmPhoneAdvancedView
